<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  <t4-container title="{{ 'Turbo.Bookings.OrderServiceDialog.headOrderService' | translate : 'Order a service' }}" [isLoading]="isLoading">
    <div class="row">
      <div class="col-12" style="margin-top:5px;">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>{{ 'Turbo.Bookings.OrderServiceDialog.Description' | translate : 'Description' }}</mat-label>
          <textarea matInput [(ngModel)]="description" placeholder="{{ 'Turbo.Bookings.OrderServiceDialog.cmdDescription' | translate : 'Please provide description for the service' }}" matTextareaAutosize matAutosizeMinRows="6" matAutosizeMaxRows="6"></textarea>
        </mat-form-field>
      </div>
      <div class="col-12" style="margin-top: 5px; margin-bottom: 5px;">
        <mat-checkbox [(ngModel)]="disableTrailer">{{ 'Turbo.Bookings.OrderServiceDialog.DisableTrailer' | translate : 'Disable the trailer'}}</mat-checkbox>
      </div>
      <div class="col-12" style="margin-top: 5px; margin-bottom: 5px;">
        <mat-label>{{ 'Turbo.Bookings.OrderServiceDialog.WarningMessage' | translate : 'Note: The service will come with a charge payable by the customer. The exact cost will be determined based on the service provided.' }}</mat-label>
      </div>
    </div>
  </t4-container>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="primary" style="margin: 5px;" [disabled]="!description || isLoading" (click)="requestService()">{{ 'Turbo.Bookings.OrderServiceDialog.cmdRequestService' | translate : 'Request service' }}</button>
</mat-dialog-actions>
